import script from "./TranscriptContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptContent.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptContent.vue?vue&type=style&index=0&id=5c629a38&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c629a38"]])

export default __exports__